// import $ from 'jquery';
import objectFitImages from 'object-fit-images';
import {} from './components/pseudo-style';
import slider404 from './components/slider-404';
import sliderSlick from './components/slider-slick';
import aboutHistory from './components/about-history';
import adventCalendar from './components/advent-calendar';
import accordion from './components/accordion';
import beforeAfterImage from './components/builder/before-after-image';
import imageLeftContentRight from './components/builder/image-left-content-right';
import newsletterSection from "./components/builder/newsletter-section";
//import logosSection from "./components/builder/logos-section";
import popupProductsApi from "./components/builder/popup-products-api";
import productLineSlider from "./components/product-line-slider";
import timelineSlider from './components/timeline-slider';
import paroller from 'paroller.js';
import YoutubePlayer from 'yt-player';
import checkWindowWidth from './components/check-window-width';
import tabs from './components/tabs';
import navigationLanguage from './components/navigation-language';
import gTagEvents from './components/gTagEvents';

// From branch junior-line-fixes
import popup from './components/popup';
import ytVideoPopup from './components/yt-video-popup';
import vimeoPopup from './components/vimeo-video-popup';
import multiVideoPlayer from './components/multivideo-overlay';

// From branch language-popup-2
import { MainMenu } from './components/main-menu';
import Hero from './components/hero';
import HorizontalSlider from './components/horizontal-slider';
import Slider from './components/slider';
import notifications from './components/notifications';

import subscription from './components/subscription-popup';
import productRowPopup from './components/product-row-popup';
import scrollDown from './components/scroll-down';

import qualityForm from './components/quality-form';
import customJquery from './components/custom-jquery';

// Floating labels
import FloatLabels from 'float-labels.js';

import lazySizes from 'lazysizes';
lazySizes.init();
// Bootstrap Dropdown
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';

import aboutContact from './components/about-contact';
import svg4everybody from 'svg4everybody'
import Quiz from './components/quiz'
import CookiePopup from './components/cookie'
import NCookiePopup from './components/ncookie'
import Contest from './components/contest'
import PrizeGame from './components/prize-game'
import PrizeGame2022 from './components/prize-game-2022'
import CarouselGallery from './components/carouselGallery'
import quizMyflavour from './components/quiz-myflavour'
import VideoBlock2022 from "./components/video-block-2022"
import TeaserForm from './components/teaser-form'
import FormPrizePage2023  from './components/form-prize-page-2023'

//
new Slider({ container: '.main .slider' });
new Slider({ container: '.exclusive .slider', mobile: true });

// each tab has its own slider
new HorizontalSlider('#slider-core-1', { desktop: false, centerMobile: true, sliderPanelBaseDocument: true });
new HorizontalSlider('#slider-core-2', { desktop: false, centerMobile: true, sliderPanelBaseDocument: true });
new HorizontalSlider('#slider-core-3', { desktop: false, centerMobile: true, sliderPanelBaseDocument: true });
new HorizontalSlider('#slider-core-4', { desktop: false, centerMobile: true, sliderPanelBaseDocument: true });
new HorizontalSlider('#slider-junior', { desktop: false, centerMobile: true, marginOffset: 15 });
new HorizontalSlider('#slider-custom', { desktop: false, centerMobile: true });
new HorizontalSlider('#related-articles', { desktop: false, centerMobile: false, centerTablet: false });
new HorizontalSlider('#articles-list', { desktop: false, tablet: false, centerMobile: false, centerTablet: false });

let currentState = checkWindowWidth();

$.noConflict();
$(function () {

  // When the user scrolls the page, execute myFunction
  var navbar = document.querySelector('.mobile-sticky');
  var body = document.body;
  var sticky = 420;
  var lastScrollTop = 0;

  // sticky desktop menu
  document.addEventListener('scroll', (evt) => {
	  var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
	  if (st > 0) {
		  body.classList.add('is_scroll');
	  } else {
		  body.classList.remove('is_scroll');
	  }

  }, {
      capture: true,
      passive: true
    });

  // Sticky navbar Post
  if (document.querySelector('.mobile-sticky')) {
    document.addEventListener('scroll', (evt) => {
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

      if (window.pageYOffset >= sticky) {
        navbar.classList.add('mobile-sticky--active');
      } else {
        navbar.classList.remove('mobile-sticky--active');
      }
    }, {
      capture: true,
      passive: true
    })
  }

  // Macedonia prize game tabs

  const tabsNav = document.querySelectorAll('[data-tab-id]');


  if (tabsNav.length > 0 ) {

    const arrowLeft = document.querySelectorAll('.prize-winners__week__arrow-left');
    const arrowRight = document.querySelectorAll('.prize-winners__week__arrow-right');
    tabsNav.forEach((tab) => {
      arrows();

      // Arrows tabs navigation
      function arrows() {
        arrowLeft.forEach((arrowL) => {
          arrowL.addEventListener('click', () => {
            let navtoHideAll = document.querySelectorAll('[data-tab-id].selected');
            console.log('test1');
            for (let navtoH of navtoHideAll) {
              setTimeout(function(){
                if ( navtoH.previousElementSibling.classList.contains('prize-winners__form-week')) {
                  navtoH.classList.remove('selected');
                  navtoH.previousElementSibling.classList.add('selected');

                  let tabId = document.querySelector('[data-tab-id].selected').getAttribute('data-tab-id');
                  let tabToHide = document.querySelector('[data-tab="true"]:not(.d-none)');
                  let tabToShow = document.querySelector(`#${tabId}`);

                  if (tabToHide !== tabToShow) {
                    if (tabToShow.classList.contains('d-none')) {
                      tabToShow.classList.remove('d-none')
                    }

                    if (tabToHide) {
                      tabToHide.classList.add('d-none')
                    }
                  }
                }
              }, 100);
            }
          });
        });
        arrowRight.forEach((arrowR) => {
          arrowR.addEventListener('click', () => {
            let navtoHideAll = document.querySelectorAll('[data-tab-id].selected');
            for (let navtoH of navtoHideAll) {
              setTimeout(function(){
                if ( navtoH.nextElementSibling.classList.contains('prize-winners__form-week')) {
                  navtoH.classList.remove('selected');
                  navtoH.nextElementSibling.classList.add('selected');

                  let tabId = document.querySelector('[data-tab-id].selected').getAttribute('data-tab-id');
                  let tabToHide = document.querySelector('[data-tab="true"]:not(.d-none)');
                  let tabToShow = document.querySelector(`#${tabId}`);

                  if (tabToHide !== tabToShow) {
                    if (tabToShow.classList.contains('d-none')) {
                      tabToShow.classList.remove('d-none')
                    }

                    if (tabToHide) {
                      tabToHide.classList.add('d-none')
                    }
                  }
                }
              }, 100);
            }
          });
        });
      }

      tab.addEventListener('click', () => {
        tabs();
      });

      // Numbers tabs navigation
      function tabs() {
        let tabId = tab.getAttribute('data-tab-id')
        let tabToHide = document.querySelector('[data-tab="true"]:not(.d-none)')
        let tabToShow = document.querySelector(`#${tabId}`)
        let navtoHide = document.querySelectorAll('[data-tab-id].selected');
        let navToShow = document.querySelectorAll(`[data-tab-id="${tabId}"]`);


        if (tabToHide !== tabToShow) {
          if (tabToShow.classList.contains('d-none')) {
            tabToShow.classList.remove('d-none')
          }

          if (tabToHide) {
            tabToHide.classList.add('d-none')
          }
        }

        for (let navtoH of navtoHide) {
          for (let navToS of navToShow) {
            if (navtoH !== navToS) {
              if (navtoH.classList.contains('selected')) {
                navtoH.classList.remove('selected')
              }

              if (navToS) {
                navToS.classList.add('selected')
              }
            }
          }
        }
      }

    })
  }

  // Track scrolling % on GA
  document.addEventListener('scroll', function () {
      var h = document.documentElement,
          b = document.body,
          st = 'scrollTop',
          sh = 'scrollHeight';

      var percent = parseInt((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100);

      if (localStorage.getItem('tracking-analytics') === 'true') {
        if (percent == 25) {
            ga('send', 'event', 'Scrolling', 'moreThan25%', 'core', {'nonInteraction': 1});
        } else if (percent == 50) {
            ga('send', 'event', 'Scrolling', 'moreThan50%', 'core', {'nonInteraction': 1});
        } else if (percent == 75) {
            ga('send', 'event', 'Scrolling', 'moreThan75%', 'core', {'nonInteraction': 1});
        } else if (percent == 90) {
            ga('send', 'event', 'Scrolling', 'moreThan90%', 'core', {'nonInteraction': 1});
        }
      }

    }, {passive: true});



  new Hero();

  svg4everybody();

  new Quiz({ container: '#questions' });
  new CookiePopup();
  new NCookiePopup();

  new Contest();
  new PrizeGame();
  new PrizeGame2022();
  new TeaserForm();
  new CarouselGallery();
  new imageLeftContentRight();
  new newsletterSection();
  new beforeAfterImage();
  new gTagEvents();
  new VideoBlock2022();
  new popupProductsApi();
  new FormPrizePage2023();
  //new logosSection();

  slider404.init();
  timelineSlider.init();
  tabs.init();
  sliderSlick.init();
  navigationLanguage.init();
  aboutHistory.init();
  adventCalendar.init();
  subscription.init();
  productRowPopup.init();

  new productLineSlider();
  new vimeoPopup();

  // From branch language-popup-2
  notifications.init();
  popup.init();
  ytVideoPopup.init();
  multiVideoPlayer.init();
  let mainMenu = new MainMenu('#main-menu-popup');
  scrollDown.init();
  aboutContact.init();

  qualityForm.init();
  customJquery.init();
  quizMyflavour.init();
  // Floating labels

  $('.product-overlay-item').paroller();

  if ($('.fl-form').length > 0) {
    new FloatLabels('form');
  }

  var images = $('.image-object-fit');
  if (images.length) {
    objectFitImages(document.querySelectorAll('.image-object-fit'));
  }

  circleAnimation();
  inViewport();


  $('.js-parallax-item').paroller();


  $('.js-video-block').each(function () {
    $(this).append('<div id="video-' + $(this).data('videoId') + '"></div>');

    const player = new YoutubePlayer('#video-' + $(this).data('videoId') + '', {
      controls: 0,
      info: 0,
      related: 0,
      annotations: 0,
      captions: 0,
      modestBranding: 1,
      playerVars: {
        rel: 0,
        showinfo: 0,
        ecver: 2
      }
    });
    player.load($(this).data('videoId'));

    player.mute();
    player.play();

    player.on('ended', () => {
      player.play();
    });

  });

  //carouselAccordion();
  accordion.init();
  // productImageHero();
  nutrientsToggle();

  let $root = $('html, body');

  // Slow scroll on #something link click
  $('a[href^="#"].anchor-link, #main-slider2 a[href^="#"]').click(function() {
      var href = $.attr(this, 'href');
      $root.animate({
          scrollTop: $(href).offset().top
      }, 500, function () {
          window.location.hash = href;
      });

      return false;
  });
});


$(window).scroll(function () {
  inViewport();
});


$(window).on('resize', () => {
  if (currentState !== checkWindowWidth()) {
    currentState = checkWindowWidth();
    //carouselAccordion();
  }
});

$(document).ready(function(){
  $('body').addClass('dom-ready');
});


function circleAnimation() {
  let timer;
  $('.brez-label').on('mouseenter', function () {
    $('.animated-image').addClass('rotate-fwd').removeClass('pause');
    $('.animated-image-wrapper').addClass('pause');
    clearTimeout(timer);
  }).on('mouseleave', function () {
    $('.animated-image').addClass('pause');
    $('.animated-image-wrapper').removeClass('pause').addClass('rotate-reverse');
    timer = setTimeout(() => {
      $('.animated-image-wrapper').addClass('pause');
    }, 3000);
  });
}


function inViewport() {
  $('.active-area').each(function () {
    let divPos = $(this).offset().top,
      topOfWindow = $(window).scrollTop();

    if (divPos < topOfWindow + $(window).height()) {
      $(this).addClass('visible');
    }
  });
}

function nutrientsToggle() {

  let activeClass = 'visible',
    nutrientLabels = $('.js-nutrient-labels'),
    nutritionalInfo = $('.js-nutritional-value'),
    toggler = $('.js-toggle-nutrients'),
    nutrientLabelsStateText = toggler.data('closed-text'),
    nutritionalInfoStateText = toggler.data('opened-text');

  toggler.on('click', (e) => {
    e.preventDefault();

    if (nutrientLabels.hasClass(activeClass)) {
      nutrientLabels.removeClass(activeClass);
      nutritionalInfo.addClass(activeClass);
      $(e.currentTarget).text(nutritionalInfoStateText).addClass('opened');
    } else {
      nutrientLabels.addClass(activeClass);
      nutritionalInfo.removeClass(activeClass);
      $(e.currentTarget).text(nutrientLabelsStateText).removeClass('opened');
    }
  });

}

$('.modal').on('shown.bs.modal', function (e) {
  $('html').addClass('overflow-hidden');
})

$('.modal').on('hidden.bs.modal', function (e) {
  $('html').removeClass('overflow-hidden');
})

//Terms page
$(document).ready(function(){
  $('.terms-button').on('click', function (e) {
    $('.terms-button').removeClass('active');
    $(e).addClass('active');
  });
});

//Scroll to newsletter
$(document).ready(function(){
  if(window.location.hash === "#newsletter") {
    $('html, body').animate({
      scrollTop: $("#newsletter").offset().top
    }, 500);
  }
});

